/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestGridResultModelSearchResultModel } from '../../models/request-grid-result-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface PathologySearchPathologyRequestPost$Params {
      body?: SearchRequestModel
}

export function pathologySearchPathologyRequestPost(http: HttpClient, rootUrl: string, params?: PathologySearchPathologyRequestPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<RequestGridResultModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, pathologySearchPathologyRequestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PathologyStrictHttpResponse<RequestGridResultModelSearchResultModel>;
    })
  );
}

pathologySearchPathologyRequestPost.PATH = '/Pathology/SearchPathologyRequest';
